import { Zap } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Marquee() {
  const { paymentsMode } = useCart();
  const ITEMS = [
    "Drop 07 now live",
    "Free shipping over $999",
    "Promo: VOLTAIC20 — 20% off",
    paymentsMode === "live" ? "Live payments on" : "Stripe test mode active",
    "15 devices. Zero compromise.",
  ];

  const Row = ({ hidden }) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span
          key={i}
          className="flex items-center gap-6 whitespace-nowrap pr-6 font-mono text-[11px] uppercase tracking-[0.28em] text-voltaic-muted"
        >
          {t}
          <Zap size={12} className="shrink-0 text-voltaic-cyan" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="marquee" className="relative overflow-hidden border-y border-voltaic-line bg-voltaic-surface/60 py-4">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
